var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "services-full" }, [
    _c("div", { staticClass: "services-full__title" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("services_1")) + "\n  ")
    ]),
    _c("div", { staticClass: "services-full__subtitle" }, [
      _vm._v("\n    " + _vm._s(_vm.$t("services_2_1")) + "\n  ")
    ]),
    _c(
      "div",
      { staticClass: "services-full__content" },
      [
        _c(
          "services-item-view",
          { attrs: { variant: "has-detail has-detail--right" } },
          [
            _c(
              "template",
              { slot: "icon" },
              [
                _c("icon-service-strategy-view", {
                  directives: [
                    {
                      name: "inview",
                      rawName: "v-inview:class",
                      value: ["animate"],
                      expression: "['animate']",
                      arg: "class"
                    }
                  ]
                })
              ],
              1
            ),
            _c("template", { slot: "title" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_3")) + "\n      ")
            ]),
            _c("template", { slot: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_7")) + "\n      ")
            ])
          ],
          2
        ),
        _c(
          "services-item-view",
          { attrs: { variant: "has-detail has-detail--bottom" } },
          [
            _c(
              "template",
              { slot: "icon" },
              [
                _c("icon-service-ux-view", {
                  directives: [
                    {
                      name: "inview",
                      rawName: "v-inview:class",
                      value: ["animate"],
                      expression: "['animate']",
                      arg: "class"
                    }
                  ]
                })
              ],
              1
            ),
            _c("template", { slot: "title" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_4")) + "\n      ")
            ]),
            _c("template", { slot: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_8")) + "\n      ")
            ])
          ],
          2
        ),
        _c(
          "services-item-view",
          { attrs: { variant: "has-detail has-detail--top" } },
          [
            _c(
              "template",
              { slot: "icon" },
              [
                _c("icon-service-ui-view", {
                  directives: [
                    {
                      name: "inview",
                      rawName: "v-inview:class",
                      value: ["animate"],
                      expression: "['animate']",
                      arg: "class"
                    }
                  ]
                })
              ],
              1
            ),
            _c("template", { slot: "title" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_5")) + "\n      ")
            ]),
            _c("template", { slot: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_9")) + "\n      ")
            ])
          ],
          2
        ),
        _c(
          "services-item-view",
          { attrs: { variant: "has-detail has-detail--left" } },
          [
            _c(
              "template",
              { slot: "icon" },
              [
                _c("icon-service-dev-view", {
                  directives: [
                    {
                      name: "inview",
                      rawName: "v-inview:class",
                      value: ["animate"],
                      expression: "['animate']",
                      arg: "class"
                    }
                  ]
                })
              ],
              1
            ),
            _c("template", { slot: "title" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_6")) + "\n      ")
            ]),
            _c("template", { slot: "content" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("services_10")) + "\n      ")
            ])
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-307cb565", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-307cb565","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/services/services-full-view.vue
// module id = 504
// module chunks = 23